import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import BlankLayout from "go-core/components/Layout/BlankLayout";
import ResetPasswordForm from "./ResetPasswordForm";

const SecurityResetPasswordPage = () => {
	const { t } = useTranslation();

	return (
		<BlankLayout>
			<div className="layout-account layout-login layout-login-center">
				<div className="layout-login-box">
					<img className="form-login-dots" src="/graphics/login/dots-yellow.svg" alt="Yellow dots" />
					<div className="form-login">
						<Link to="/">
							<img className="logo-img" alt="GoPOS Logo" src={"/graphics/goaccounts-logo-b.svg"} />
						</Link>
						<h3>{t("modules.security.field.reset_password.title")}</h3>
						<ResetPasswordForm />
						<p className="login-contact-link">
							{t("modules.security.field.remember_password.title")}{" "}
							<Link to="/login">{t("modules.security.action.back_to_login.title")}</Link>
						</p>
					</div>
				</div>
				<div className="login-footer">
					<ul className="list-inline">
						<li className="list-inline-item">
							<a href="https://www.gopos.pl">© GoPOS</a>
						</li>
						<li className="list-inline-item">
							<a href="https://www.gopos.pl/contact">{t("modules.security.field.contact.title")}</a>
						</li>
						<li className="list-inline-item">
							<a href="https://www.gopos.pl/privacy-policy">{t("modules.security.field.rules.title")}</a>
						</li>
					</ul>
				</div>
			</div>
		</BlankLayout>
	);
};
export default SecurityResetPasswordPage;
